import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { API_PATH } from 'src/app/utils/constants/api.constants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DailyLogService {

  constructor(private http: HttpClient,private commonService:CommonService) {
  }

  saveDailyLog(data) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.COSTING_DAILY_LOG;
    return this.http.post(url, data);
  }

  getDailyLogs(project_id, contractor_account_id) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.GET_DAILY_LOGS;
    const obj={ params: {
      project_id: project_id,
      contractor_account_id: contractor_account_id
    }
  }
  const headers = new HttpHeaders().set('x-user-role', 'franchisee');
  if (this.commonService?.isFranchisee) obj['headers']=headers;
    return this.http.get<any>(url, obj);
  }

  getActiveProject(id) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.ACTIVE_PROJECTS;

    if (!this.commonService?.isFranchisee){
      return this.http.get<any>(url, {
        params: {
          project_id: id
        }
      })
    }
    else {
      const headers = new HttpHeaders().set('x-user-role', 'franchisee');
      return this.http.get<any>(`${url}?contractor_id=${this.commonService.franchiseeContractor_id}`, { headers,
        params: {
          project_id: id
        }
       })
    }
  }

  getViewDailyLogs(project_id, user_id, user_type) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.VIEW_DAILY_LOGS;
    if (!this.commonService?.isFranchisee){
      return this.http.get<any>(url, {
        params: {
          project_id: project_id,
          user_id: user_id,
          user_type: user_type
        }
      });
    }
    else {
      const headers = new HttpHeaders().set('x-user-role', 'franchisee');
      return this.http.get<any>(`${url}?contractor_id=${this.commonService.franchiseeContractor_id}`, { headers, params: {
        project_id: project_id,
        user_id: user_id,
        user_type: user_type
      } })
    }
  }
  getDailyLogsOnId(obj: any): Observable<any> {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.SITE_MANAGEMENT_DAILY_LOGS_VIEW;
    if (!this.commonService?.isFranchisee){
      return this.http.get(url, {
        params: obj
      });
    }
    else {
      const headers = new HttpHeaders().set('x-user-role', 'franchisee');
      return this.http.get<any>(`${url}?contractor_id=${this.commonService.franchiseeContractor_id}`, { headers, params: obj })
    }
  }
  multipleUploadDoc(req) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.MULTIPLE_FILE_UPLOAD;
    return this.http.post(url, req);
  }
  fileUpload(data) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.BIDS_FILE_UPLOAD;
    return this.http.post(url, data);
  }

  getCallPM(project_id) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.BIDS_CALL_PM;
    return this.http.get<any>(url, {
      params: {
        project_id: project_id
      }
    });
  }

  getFiles(project_id) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.GET_FILES;

    if (!this.commonService?.isFranchisee) {
      return this.http.get<any>(url, {
        params: {
          project_id: project_id
        }
      });
    }
    else {
      const headers = new HttpHeaders().set('x-user-role', 'franchisee');
      return this.http.get<any>(`${url}?contractor_id=${this.commonService.franchiseeContractor_id}`, { headers ,params: {
        project_id: project_id
      }})
    }
  }

  getProjects() {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.GET_PROJECTS;
    if (!this.commonService?.isFranchisee) return this.http.get<any>(url);
    else {
      const headers = new HttpHeaders().set('x-user-role', 'franchisee');
      return this.http.get<any>(`${url}?contractor_id=${this.commonService.franchiseeContractor_id}`, { headers })
    }
  }
  deleteFileById(req) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.DELETE_APPROVAL_UPLOAD;
    return this.http.post(url, req);
  }

 addComment(data) {
    const url = environment.BASE_URL + API_PATH.ADD_COMMENT;
    return this.http.post(url, data)
  }

   uploadImage(req) {
   const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.UPLOAD_IMAGE;
    return this.http.post(url, req);  
  }


  deleteAttachment(id: string, file_id: string) {
  const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.DELETE_ATTACH;
  const params = new HttpParams()
    .set('daily_log_id', id)
    .set('file_id', file_id);
  return this.http.delete(url, { params });
}

  // getDailyLogsOnId(obj: any): Observable<any> {
  //   const options = {} as MakeAPIRequestOptions;
  //   options.params = {
  //    ...obj
  //   }
  //   return this.makeGetAPIRequest(this.SITE_MANAGEMENT_DAILY_LOGS_VIEW, options);
  // }
}
